import React, { createClass, PropTypes } from 'react';
import getClassNames from 'classnames';
import { Paper } from 'material-ui';
import SearchBar from './search-bar';
import Carousel from './carousel';
import $ from 'jquery';

const Card = createClass({

  propTypes: {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    padded: PropTypes.bool,
    isFixed: PropTypes.bool,
    searchHeader: PropTypes.any,
    className: PropTypes.string,
    headerImages: PropTypes.array,
    style: PropTypes.object,
    children: PropTypes.any,
    listCard: PropTypes.any,
    locationData: PropTypes.any,
    companyData: PropTypes.any,
    productData: PropTypes.any,
    titleBarExtra: PropTypes.any,
    contentsStyle: PropTypes.object,
    isSticky: PropTypes.bool,
    defaultValue: PropTypes.string,
  },

  getDefaultProps() {
    return {
      padded: true,
    };
  },

  componentDidMount() {
    const resizeCss = function (wrapper) {
      const wRatio = 744 / this.naturalWidth;
      const hRatio = 320 / this.naturalHeight;
      const ratio = Math.min(wRatio, hRatio);

      if (this.naturalWidth > this.naturalHeight) {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto',
        });
      } else {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto',
        });
      }
    };

    const $image = $('.tc-card-header-image');
    $image.load(function () {
      resizeCss.call(this, $image);
    });
  },

  render() {
    let outerChildren;
    let innerChildren;
    const classes = getClassNames('tc-card', this.props.className, {
      'is-padded': this.props.padded,
      'is-fixed': this.props.isFixed,
      'is-sticky': this.props.isSticky,
    });

    if (this.props.children.length === 2 && this.props.listCard) {
      outerChildren = (
        <div className="tc-card-header-tags">
          {this.props.children[0]}
        </div>
      );
      innerChildren = this.props.children[1];
    } else {
      innerChildren = this.props.children;
    }

    if (this.props.locationData || this.props.companyData
       || this.props.productData) {
      innerChildren = this.props.children;
    }
    const titleElement = this.props.title ? (
      <h4 className="tc-card-header-title">{this.props.title}</h4>
    ) : outerChildren;

    const subTitleElement = this.props.subtitle ? (
      <div style={{ clear: 'left' }}>{this.props.subtitle}</div>
    ) : null;
    let width;
    if (this.props.isFixed && document.getElementsByClassName('connections-list').length) {
      width = { width: window.getComputedStyle(document.getElementsByClassName('connections-list')[0]).getPropertyValue('width') };
    }
    const searchHeader = titleElement && this.props.searchHeader ? (
      <div>
        <div className="tc-card-header search-header">
          <SearchBar className="search-header-search-bar" {...this.props} defaultValue={this.props.defaultValue}/>
        </div>
        <div className="tc-card-header search-header">
          {titleElement}
          {this.props.titleBarExtra}
          {subTitleElement}
        </div>
      </div>
    ) : null;

    let header;
    if (this.props.headerImages && this.props.headerImages.length) {
      if (this.props.headerImages.length > 1) header = <Carousel photos={this.props.headerImages}/>;
      else {
        header = (
          <div style={{ backgroundColor: 'black' }}>
            <img className="tc-card-header-image" src={this.props.headerImages} />
          </div>
        );
      }
    } else {
      header = (
        <div style={width} className="tc-header-container">
          {searchHeader}
        </div>
      );
    }

    return (
      <Paper className={classes} style={this.props.style}>
        {header}
        <div className="tc-card-contents" style={this.props.contentsStyle}>
          {innerChildren}
        </div>
      </Paper>
    );
  },

});

export default Card;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/search-bar-card.jsx